import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../../ElementControlsStyles';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import {isFullWidthComponent} from 'crazyEditor/redux/modules/element/helpers/elementPositionHelpers';
import { BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import * as Colors from 'material-ui/styles/colors';
import { ALIGN_DIRECTION, alignSelectedElements } from 'crazyEditor/redux/modules/element/actions/elementLayoutActions';

export function shouldRenderAlignToPage(selectedElements) {
  return !_.every(selectedElements, isFullWidthComponent);
}

@connect(
  false,
  {alignSelectedElements, closeLazyPanel}
)
@Radium
export default class AlignObjectsControlPanel extends Component {
  onCancel = () => {
    const { closeLazyPanel, panelName } = this.props;
    closeLazyPanel(panelName);
  };

  render() {
    const { open, panelName, anchorEl, alignSelectedElements, panelProps} = this.props;
    const { selectedElementIds, selectedElements, viewMode, isMultiSelect } = panelProps;

    return (
      <BasePopoverPanel
        open={open}
        panelName={panelName}
        anchorEl={anchorEl}
        onRequestClose={this.onCancel}
        popoverProps={{
          anchorOrigin: {horizontal: 'right', vertical: 'bottom'},
          targetOrigin: {horizontal: 'right', vertical: 'top'}
        }}
        style={{padding: '20px'}}
      >
        {isMultiSelect &&
        <div>
          <div style={baseStyles.menuPanelTitle}>ALIGN</div>
          <div style={[baseStyles.menuPanelBody, {paddingBottom: '20px'}]}>
            <ul style={[baseStyles.menuPanelBodyList]}>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M18,11H6V3H18v8Zm4,2v8H6V13H22Zm-2,2H8v4H20V15ZM2,24H4V0H2V24Z"
                  tooltip="Align Left"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.LEFT);}}
                  tooltipPosition="top-center"
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M20,13H13V11h5V3H13V0H11V3H6v8h5v2H4v8h7v3h2V21h7V13Zm-2,6H6V15H18v4Z"
                  tooltip="Align Center"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.CENTER_HORIZONTAL);}}
                  tooltipPosition="top-center"
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M18,11H6V3H18v8Zm-2,4H4v4H16V15m2-2v8H2V13H18ZM22,0H20V24h2V0Z"
                  tooltip="Align Right"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.RIGHT);}}
                  tooltipPosition="top-center"
                  iconColor={Colors.grey700}
                />
              </li>
            </ul>
            <ul style={baseStyles.menuPanelBodyList}>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M13,6h8V18H13V6ZM3,6h8V22H3V6ZM5,20H9V8H5V20ZM0,2V4H24V2H0Z"
                  tooltip="Align Top"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.TOP);}}
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M24,11H21V6H13v5H11V4H3v7H0v2H3v7h8V13h2v5h8V13h3V11ZM9,18H5V6H9V18Z"
                  tooltip="Align Middle"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.CENTER_VERTICAL);}}
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M21,18H13V6h8V18ZM11,18H3V2h8V18ZM9,4H5V16H9V4ZM0,20v2H24V20H0Z"
                  tooltip="Align Bottom"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.BOTTOM);}}
                  iconColor={Colors.grey700}
                />
              </li>
            </ul>
          </div>
        </div>
        }
        {shouldRenderAlignToPage(selectedElements) &&
        <div>
          <div style={baseStyles.menuPanelTitle}>ALIGN TO PAGE</div>
          <div style={baseStyles.menuPanelBody}>
            <ul style={baseStyles.menuPanelBodyList}>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M1,0V24H23V0H1ZM21,22H3V2H21V22ZM11,10H5V6h6v4Zm4,2H5v6H15V12Zm-2,4H7V14h6v2Z"
                  tooltip="Align to Page Left"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.PAGE_LEFT);}}
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M1,0V24H23V0H1ZM21,22H3V2H21V22Z M11,20h2V18h5V12H13V10h3V6H13V4H11V6H8v4h3v2H6v6h5v2ZM8,14h8v2H8V14Z"
                  tooltip="Align to Page Center"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.PAGE_CENTER);}}
                  iconColor={Colors.grey700}
                />
              </li>
              <li style={baseStyles.menuPanelBodyListItem}>
                <CustomSvgIconButton
                  iconPath="M1,0V24H23V0H1ZM21,22H3V2H21V22ZM19,10H13V6h6v4Zm0,2H9v6H19V12Zm-2,4H11V14h6v2Z"
                  tooltip="Align to Page Right"
                  onClick={() => {alignSelectedElements(viewMode, selectedElementIds, ALIGN_DIRECTION.PAGE_RIGHT);}}
                  iconColor={Colors.grey700}
                />
              </li>
            </ul>
          </div>
        </div>
        }
      </BasePopoverPanel>
    );
  }
}

AlignObjectsControlPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.shape({
    selectedElementIds: PropTypes.array.isRequired,
    selectedElements: PropTypes.array.isRequired,
    viewMode: PropTypes.string.isRequired,
    isMultiSelect: PropTypes.bool.isRequired
  })
};